import { makeStyles } from "@material-ui/core";
import FormHelperText from "@material-ui/core/FormHelperText";
import { useDialog } from "muibox";
import React, { useCallback } from "react";
import {
  Create,
  RadioButtonGroupInput,
  SimpleForm,
  TextInput,
  useMutation,
  useNotify,
  useRedirect,
  useTranslate,
} from "react-admin";
import { ALL_PARTICIPANT_TYPES } from ".";
import { required } from "../../../shared/validation/validate";
import {
  validateNameLength,
  validateParticipantCode,
} from "../../../shared/validations";
import BackActions from "../../action/BackActions";
import SaveOnlyToolbar from "../../toolbar/SaveOnlyToolbar";
import { confirmAndMutate } from "../promiseMutation";

export const ParticipantTypeInputDescription = ({ record }) => {
  const translate = useTranslate();
  const classes = useStyles();
  return (
    <>
      <p className={classes.helperText}>{translate(record.name)}</p>
      <FormHelperText>{translate(record.helperText)}</FormHelperText>
    </>
  );
};

const useStyles = makeStyles({
  checkboxLabel: {
    transformOrigin: "left",
  },
  helperText: {
    marginTop: "20px",
    marginBottom: "0px",
  },
  textboxWidth: {
    width: "50%",
  },
});

export const transform = (values) => {
  return {
    ...values,
    code: values.code?.toUpperCase(),
  };
};

export const OrgCreate = (props) => {
  const [mutate] = useMutation();
  const notify = useNotify();
  const redirect = useRedirect();
  const translate = useTranslate();
  const dialog = useDialog();
  const classes = useStyles();

  const save = useCallback(
    async (values) => {
      return await confirmAndMutate({
        resource: props.resource,
        mutate,
        redirect,
        translate,
        transform,
        values,
        dialog,
        dialogOptions: {
          title: "portal.dialog.confirmOrgCreate",
          message: "portal.dialog.confirmOrgCreateContent",
        },
        notify,
        successNotificationMessage: "portal.messages.orgCreated",
      });
    },
    [mutate, notify, redirect, dialog, translate, props.resource]
  );

  return (
    <Create
      undoable={false}
      title={translate("portal.action.orgCreate")}
      actions={<BackActions {...props} />}
      {...props}
    >
      <SimpleForm
        save={save}
        toolbar={<SaveOnlyToolbar disabledTooltipLabel="" />}
      >
        <TextInput
          className={classes.textboxWidth}
          source="name"
          label="portal.label.orgName"
          validate={validateNameLength}
        />
        <TextInput
          inputProps={{
            maxLength: 4,
            style: { textTransform: "uppercase" },
          }}
          className={classes.textboxWidth}
          source="code"
          label="portal.label.partCode"
          helperText="portal.label.helperText.fourLetterCode"
          validate={validateParticipantCode}
        />
        <RadioButtonGroupInput
          label="portal.label.partType"
          row={false}
          classes={
            {
              label: classes.checkboxLabel,
            } as any
          }
          validate={required()}
          source="partType"
          choices={ALL_PARTICIPANT_TYPES}
          optionText={<ParticipantTypeInputDescription {...props} />}
        />
      </SimpleForm>
    </Create>
  );
};

export default OrgCreate;
